(function () {
  'use strict';

  angular.module('app').component('invoiceList', invoiceList());

  function invoiceList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        totalAmounts: '<',
        onShowItem: '&',
      },
      controller: InvoiceListCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/invoices/invoice-list/invoice-list.component.html',
    };
  }

  InvoiceListCtrl.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'InvoiceService',
    'DocumentService',

    'currencyService',
  ];

  function InvoiceListCtrl(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    InvoiceService,
    DocumentService,

    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_invoice_accountadmin'),
      canUpdate: AbilityService.can('update_invoice_accountadmin'),
      canDestroy: AbilityService.can('destroy_invoice_accountadmin'),
    };

    vm.invoiceStatuses = [...config.INVOICE_STATUSES];
    vm.invoiceStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.atvCrStatuses = [...config.ATV_CR_STATUSES];
    vm.atvCrStatuses.unshift({
      label: 'ALL',
      value: null,
    });

    vm.statusDraft = 'draft';
    vm.statusPaid = 'paid';
    vm.statusAccepted = 'accepted';
    vm.statusSent = 'sent';

    const apiUrl = 'invoice_reports';
    vm.urlXls = apiUrl + '/export_sales_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_sales_pdf.pdf';
    vm.reportName = 'invoices_report';

    // private properties
    // -----------------------
    const company = SessionService.getSelectedAccountCompany();
    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    let userLanguageCode = SessionService.getUserLanguage().code;
    const dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';

    vm.$onInit = function () {
      vm.atvCrEnabled = company.atv_cr_enabled;
      // vm.companyCountryCode = company.country.code;

      setInvoices(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
      setDueDatePicker();
      getCurrencies();
    };

    // public methods
    // -----------------------
    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function () {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      InvoiceService.deleteInvoice(item, vm.fetchResult());
    };

    // Atv functions
    vm.sendDocumentToAtv = function (item) {
      if (!item.canSend) return;

      vm.loadingDocument = true;
      DocumentService.sendDocumentToAtv(item, 'invoices').then(function (data) {
        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.resendDocumentToAtv = function (item) {
      if (!item.canResend) return;

      vm.loadingDocument = true;
      DocumentService.resendDocumentToAtv(item, 'invoices').then((data) => {
        console.log('resendDocumentToAtv - invlice list');
        console.log(data);

        if (data) {
          item.atv_status = data.atv_status;
          validateItemActions(item);
        }

        vm.loadingDocument = false;
      });
    };

    vm.downloadInvoicePdf = function (item) {
      InvoiceService.downloadInvoicePdf(item, userLanguageCode);
    };

    vm.notifyDocumentToClient = function (item) {
      // if (item.status !== vm.statusPaid || (vm.atvCrEnabled && item.atv_status !== vm.statusAccepted)) return;
      if (!item.canNotify) return;

      const successCallBack = function (email) {
        item.client_email_receipt = email;

        vm.loadingDocument = true;
        DocumentService.notifyDocumentToClient(item, 'invoices', email).then(function () {
          vm.loadingDocument = false;
        });
      };

      DocumentService.openNotifyDocumentToClient(
        item.client.email,
        successCallBack,
        'SEND_INVOICE_TO_CLIENT'
      );
    };

    vm.openRelatedTransactions = function (item) {
      InvoiceService.openRelatedTransactions(item, item.client);
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearDueDate = function () {
      vm.dueDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_due_date_from;
      delete vm.filterCriteria.by_due_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();

      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setInvoices(items) {
      vm.sum_accounting_grand_total = 0;
      vm.sum_accounting_balance_due = 0;

      items.forEach((item) => {
        vm.sum_accounting_grand_total += item.accounting_grand_total;
        vm.sum_accounting_balance_due += item.accounting_balance_due;
        item.date = moment(item.date).format(dateDisplay);
        item.invoice_number = item.invoice_number || '-';
        item.client_name = item.client
          ? item.client.name + ' ' + item.client.last_name
          : item.guest_name;
        item.due_date_label = item.due_date; // for status
        item.due_date = item.due_date ? moment(item.due_date).format(dateDisplay) : item.date;

        validateItemActions(item);
      });
    }

    function validateItemActions(item) {
      item.canEdit =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.status === 'draft'));
      item.canDelete = vm.permissions.canDestroy && item.status === 'draft';

      item.canSend =
        vm.permissions.canUpdate &&
        vm.atvCrEnabled &&
        item.document_type.numbering_type === 'electronic' &&
        item.atv_status === 'fail';

      item.canResend =
        (vm.permissions.canUpdate &&
          vm.atvCrEnabled &&
          item.document_type.numbering_type === 'electronic' &&
          item.atv_status === 'not_sent') ||
        item.atv_status === 'pending' ||
        item.atv_status === 'sent' ||
        item.atv_status === 'received' ||
        item.atv_status === 'processing' ||
        item.atv_status === 'sending'; // fail ??

      item.canDownload =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            (item.atv_status === vm.statusAccepted || item.atv_status === vm.statusSent)));

      item.canNotify =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.atv_status === vm.statusAccepted));

      item.canAddPayment =
        vm.permissions.canUpdate && (item.status === 'open' || item.status === 'overdue');
      item.canCreateCreditNote =
        vm.permissions.canUpdate &&
        (!vm.atvCrEnabled ||
          (vm.atvCrEnabled &&
            item.document_type.numbering_type === 'electronic' &&
            item.atv_status === 'accepted'));

      // && item.status === vm.statusPaid
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        // startDate: '',
        // endDate: '',
        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
      };

      vm.dueDatePicker = {
        startDate: '',
        endDate: '',
      };

      vm.filterCriteria = InvoiceService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );

      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());

      // vm.filterCriteria.by_status = 'unpaid';
      // vm.filterCriteria.by_status = vm.invoiceStatuses[0].value;
      // vm.filterCriteria.by_atv_status = vm.atvCrStatuses[0].value;
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }

    function setDueDatePicker() {
      let filterByDueDate = () => {
        vm.filterCriteria.by_due_date_from = vm.UtilService.startOfDayFormat(
          vm.dueDatePicker.startDate
        );

        vm.filterCriteria.by_due_date_to = vm.UtilService.endOfDayFormat(vm.dueDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.dueDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDueDate,
        rangeOptions: config.DUE_DATE_OPTIONS,
        dateDisplay: dateDisplay,
      });
    }

    function getCurrencies() {
      currencyService.getCurrency(company.currency_id).subscribe((response) => {
        vm.base_currency = response;
      });
    }

    vm.fetchResult = function () {
      // const fields = [
      //   'by_client',
      //   'by_date_from',
      //   'by_due_date_from',
      //   'by_status',
      //   'by_atv_status',
      // ];

      // const params = vm.UtilService.deleteEmptyFields(fields, vm.filterCriteria);
      // console.log(params);

      vm.loadingItems = true;
      InvoiceService.getInvoices(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalAmounts = data.totalAmounts;

        setInvoices(vm.items);

        vm.totalItems = vm.meta.totalItems;
        vm.loadingItems = false;
      });
    };
  }
})();

// vm.filterCriteria.by_date_to = moment(
//   vm.UtilService.startOfDayFormat(vm.documentDatePicker.endDate)
// ).add(1, 'days');
